// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import type { StrongOmit } from '@evolvemep/api-ts';
import type { MantineColor, MantineSize, TooltipProps } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';

export type InfoIconProps = {
  label: ReactNode | null | undefined;
  color?: MantineColor | 'inherit';
  size?: MantineSize | number;
  tooltipProps?: StrongOmit<TooltipProps, 'label'>;
  inline?: boolean;
};

export const InfoIcon = ({ label, tooltipProps, size = 'sm', ...props }: InfoIconProps) =>
  label ? (
    <AgGridStyleTooltip label={label} openDelay={0} withArrow {...tooltipProps} openOnTap>
      <EvolveIcon icon="Info" inline color="dimmed" size={size} onClick={(e) => e.stopPropagation()} {...props} />
    </AgGridStyleTooltip>
  ) : null;
